import React from 'react'
import SettingsGatewaysForm from '../components/setting/settingsGatewaysForm'

const SettingsGateways = () => {
    return (<SettingsGatewaysForm />
    )
}

export default SettingsGateways